import { useEffect, useState } from "react";
import { masterApi } from "@/contexts/MasterAuthContext";
import { Building2, TrendingUp, CreditCard, Activity, Crown } from "lucide-react";

export default function MasterDashboard() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        masterApi.get("/master/dashboard").then((r) => setData(r.data)).finally(() => setLoading(false));
    }, []);

    if (loading) return <div data-testid="master-dashboard-loading">Yükleniyor…</div>;
    if (!data) return <div>Veri yok</div>;

    const Card = ({ icon: Icon, label, value, accent, testId }) => (
        <div data-testid={testId} className="bg-[#121212] border border-[#2a2a2a] rounded-2xl p-6">
            <div className={`inline-flex items-center justify-center w-10 h-10 rounded-lg mb-4 ${accent || "bg-yellow-500/10 text-yellow-400"}`}>
                <Icon size={20} />
            </div>
            <div className="text-3xl font-extrabold tracking-tight">{value}</div>
            <div className="text-xs font-bold uppercase tracking-widest text-neutral-500 mt-1">{label}</div>
        </div>
    );

    return (
        <div data-testid="master-dashboard">
            <div className="mb-8">
                <div className="text-xs font-bold uppercase tracking-widest text-yellow-400 mb-2 flex items-center gap-2"><Crown size={14}/> Master Dashboard</div>
                <h1 className="text-4xl font-extrabold tracking-tight">Platform Genel Bakış</h1>
                <p className="text-neutral-400 mt-2">DR AI FUTBOL multi-tenant SaaS yönetimi</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 mb-8">
                <Card testId="card-total-clubs" icon={Building2} label="Toplam Kulüp" value={data.total_clubs} />
                <Card testId="card-active-clubs" icon={Activity} label="Aktif Kulüp" value={data.active_clubs} accent="bg-green-500/10 text-green-400" />
                <Card testId="card-mrr" icon={TrendingUp} label="MRR (₺/Ay)" value={Number(data.mrr_try).toLocaleString("tr-TR")} accent="bg-emerald-500/10 text-emerald-400" />
                <Card testId="card-credits" icon={CreditCard} label="Kalan Kredi" value={data.total_credits_remaining} accent="bg-blue-500/10 text-blue-400" />
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <div data-testid="plan-distribution" className="bg-[#121212] border border-[#2a2a2a] rounded-2xl p-6">
                    <h3 className="font-bold text-lg mb-4">Paket Dağılımı</h3>
                    <div className="space-y-3">
                        {Object.entries(data.plan_distribution || {}).map(([plan, count]) => (
                            <div key={plan} className="flex items-center justify-between p-3 bg-[#0a0a0a] rounded-lg border border-[#1f1f1f]">
                                <span className="capitalize font-medium">{plan}</span>
                                <span className="text-yellow-400 font-bold">{count} kulüp</span>
                            </div>
                        ))}
                    </div>
                </div>

                <div data-testid="usage-stats" className="bg-[#121212] border border-[#2a2a2a] rounded-2xl p-6">
                    <h3 className="font-bold text-lg mb-4">Kredi Tüketimi</h3>
                    <div className="space-y-3">
                        <div className="p-3 bg-[#0a0a0a] rounded-lg border border-[#1f1f1f]">
                            <div className="text-xs text-neutral-500">Toplam Tüketilen Kredi (All Time)</div>
                            <div className="text-2xl font-extrabold text-yellow-400 mt-1">{data.total_credits_used_all_time}</div>
                        </div>
                        <div className="p-3 bg-[#0a0a0a] rounded-lg border border-[#1f1f1f]">
                            <div className="text-xs text-neutral-500">Mevcut Bakiye Toplamı</div>
                            <div className="text-2xl font-extrabold text-emerald-400 mt-1">{data.total_credits_remaining}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
